import { useState, useEffect } from "react";
import CardGroup from './cardGroup';
import SubscriptionCard from './SubscriptionCard';
import { subscriptionPlans } from '../config/subscriptionPlans';
import { useSelector } from "react-redux";

export const SubscriptionPlans = ({
  variant = 'card', 
  selectedPlan,
  onPlanSelect,
  columns,
  hideButtons = false
}) => {
  const [selectedBilling, setSelectedBilling] = useState("monthly");

  const subscriptionCheck = useSelector(
    (state) => state.auth.subscription?.isSubscribed
  );

  // Set billing period based on selected plan
  useEffect(() => {
    if (selectedPlan === "pro-yearly") {
      setSelectedBilling("yearly");
    } else if (selectedPlan === "pro-monthly") {
      setSelectedBilling("monthly");
    } else if (selectedPlan === "free" || selectedPlan === "onetime") {
      setSelectedBilling("monthly"); // Free and onetime plans don't have billing, but set default
    }
  }, [selectedPlan]);

  const renderPlans = () => {
    const plans = Object.entries(subscriptionPlans).map(([key, plan]) => {
      if (key === 'pro' || key === 'premium') {
        const billing = selectedBilling;
        return {
          ...plan[billing],
          ...plan
        };
      }
      return plan;
    });

    const getGridClass = () => {
      if (!columns) {
        return 'grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4';
      }
      switch (columns) {
        case 1:
          return 'grid-cols-1';
        case 2:
          return 'grid-cols-1 sm:grid-cols-2';
        case 3:
          return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
        case 4:
          return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';
        default:
          return 'grid-cols-1';
      }
    };

    return variant === 'card' ? (
      <CardGroup
        cards={plans}
        label="Choose Your Plan"
        selectedBilling={selectedBilling}
        onBillingToggle={setSelectedBilling}
        hideButtons={hideButtons}
        currentPlan={selectedPlan}
      />
      ) : (
      <div className={`grid ${getGridClass()} gap-6`}>
        {plans.map(plan => (
          <SubscriptionCard
            key={plan.type}
            {...plan}
            onClick={() => {
              return onPlanSelect(plan.type);
            }}
            currentPlan={selectedPlan === plan.type ? plan.type : null}
            isSelected={selectedPlan === plan.type}
            selectedBilling={selectedBilling}
            onBillingToggle={setSelectedBilling}
            hideButtons={hideButtons}
          />
        ))}
      </div>
    );
  };

  return renderPlans();
};
